import { DeepPartial } from "setup/deepPartial";

import { EventFormValues } from "./types";

export const EVENT_INIT_VALUES: DeepPartial<EventFormValues> = {
  input: {},
};

export const EVENT_TAB_NAMES = {
  details: "details",
  tickets: "tickets",
  codes: "dicsount-codes",
};
